<template>
    <el-dialog title="批量生码" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="form"  ref="form">
            
            <el-form-item label="批次号" prop="batch_no" :rules="[{ required: true, message: ' ' }]"  :label-width="formLabelWidth"><el-input v-model="form.batch_no" autocomplete="off"></el-input></el-form-item>
            <el-form-item label="生成数量" prop="number" :rules="[{ required: true, message: ' ' }]"  :label-width="formLabelWidth"><el-input v-model="form.number" type="number" autocomplete="off"></el-input></el-form-item>
            <!--提交-->
            <!--提交-->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="Export">提 交</el-button>
        </div>
        
    </el-dialog>
</template>

<script>
    import SweepstakesApi from '@/api/sweepstakes.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '80px',
                /*是否显示*/
                dialogVisible: false,
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*是否加载完成*/
                loading: true,
                /*横向表单数据模型*/
                form: {
                    number: '',
                    batch_no: '',
                },
            };
        },
        props: ['open_edit','awards_id','sweepstakes_id'],
        created() {
            this.dialogVisible = this.open_edit;
        },
        methods: {
            // 导出券码
            Export() {
                let self = this;
                let form = self.form;
                if(form.number < 1) {
                    this.$message({
                        message: '数量不能小于1',
                        type: 'error'
                    });
                    return false;
                }
                form.awards_id = this.awards_id
                form.sweepstakes_id = this.sweepstakes_id
                console.log(form)
                self.$refs.form.validate(valid => {
                    if (valid) {
                    self.loading = true;
                    SweepstakesApi.addCode(form, true)
                        .then(data => {
                        self.loading = false;
                        self.$message({
                            message: '恭喜你，成功',
                            type: 'success'
                        });
                        self.dialogFormVisible()
                        })
                        .catch(error => {
                        self.loading = false;
                        });
                    } else {
                        self.loading = false;
                    }
                });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                this.$emit('closeDialog', {
                    openDialog: false
                })
            }

        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakesawards/part/AddCode.vue